import { DEFAULTS } from "./defaults.js";
import { VERTICAL_EMBED_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/loadable/node-view-renderers-loadable.js";
const pluginVerticalEmbed = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: VERTICAL_EMBED_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginVerticalEmbed
};
//# sourceMappingURL=viewer-loadable.js.map
